import { AiSparkles } from '@sharefiledev/icons';
import { qnaPiletExtensionSlots, qnaPiletOverlays } from '@sharefiledev/qna-pilet-sdk';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { configureContentQnASdk } from 'data/clients';
import { withQueryClientProvider } from 'data/helpers';
import { isDevelopmentPageEnabled } from 'utils';
import { withAppContext, withUserSettingsContext } from 'utils/context';
import { AsyncDevPage } from 'utils/devtools';
import { AiAssistantButton } from './assistant/AIAssistantButton';
import { AsyncAIAssistantDrawer } from './assistant/AsyncAIAssistantDrawer';
import { AsyncAdminSettingsPage } from './settings/AsyncAdminSettingsPage';
import {} from './utils/context/withUserSettingsContext';

export function setup(app: PiletApi) {
	// @ts-ignore
	app.registerExtension(qnaPiletExtensionSlots.AiAssistantButton, ({ params }) =>
		withUserSettingsContext(app, AiAssistantButton)({ ...params, piletApi: app })
	);
	app.registerDrawer(
		qnaPiletOverlays.useSummarization,
		// @ts-ignore
		withQueryClientProvider(withAppContext(app, AsyncAIAssistantDrawer)),
		{
			width: 'min(85vw, 385px)',
		}
	);
	// @ts-ignore
	app.registerExtension(qnaPiletExtensionSlots.QnAUserSettings, ({ params }) => {
		return withUserSettingsContext(
			app,
			AsyncAdminSettingsPage
		)({ ...params, piletApi: app });
	});

	if (isDevelopmentPageEnabled()) {
		// @ts-ignore
		app.registerPage('/qna-pilet-development', withAppContext(app, AsyncDevPage));
		app.sf.registerLeftNavComponent({
			href: '/qna-pilet-development',
			title: () => 'QnA Dev',
			icon: AiSparkles,
			weight: 50,
		});
	}

	configureContentQnASdk(app);
}
